import { createSelector } from 'reselect';

import { dashboardSelector } from 'modules/dashboard/store/selectors/dashboard';

export const customerPortalLinkSelector = createSelector(
  dashboardSelector,
  (state) => state.customerPortalLink,
);
